import { render, staticRenderFns } from "./Fraud.vue?vue&type=template&id=cec78074&"
import script from "./Fraud.vue?vue&type=script&lang=js&"
export * from "./Fraud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports